import { render, staticRenderFns } from "./AddressImporterMetadataMenu.vue?vue&type=template&id=a2307226&"
import script from "./AddressImporterMetadataMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddressImporterMetadataMenu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddressImporterMetadataMenu.vue?vue&type=style&index=0&id=a2307226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VMenu,VTextField})
